import Vue from 'vue';
import Vuex from 'vuex';

import { globalStore as global } from './modules/global';
import { twitchSettings } from './modules/twitchSettings';
import { panel } from './modules/panel';

Vue.use(Vuex);

// TODO: Refactor modules into a single store?
export default new Vuex.Store({
    modules: {
        global,
        twitchSettings,
        panel,
    },
});
